import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import {
  registerSensitiveValuesFromLocation,
  scrubBreadcrumb,
  scrubEvent,
} from './app/utils/SentryScrub';

// Antes de `Sentry.init`: después ya puede haber breadcrumbs grabados con la credencial cruda.
registerSensitiveValuesFromLocation(window.location.pathname);

Sentry.init({
  dsn: "https://e761acff6585293799f07cc491257e3f@o4507575110795264.ingest.us.sentry.io/4508458217963520",
  integrations: [
    Sentry.browserTracingIntegration(),
    // OJO antes de descomentar: el saneamiento de más abajo NO alcanza al Session Replay. El
    // replay graba DOM y red por su propio canal, así que la OI encriptada volvería a salir por
    // la URL sin pasar por `beforeSend`. Activarlo exige antes enmascarar la URL en el propio
    // replay (`maskAllText`/`beforeAddRecordingEvent`) y volver a correr `npm run verify:scrub`
    // extendido a ese canal. Las dos tasas de `replays*SampleRate` de acá abajo ya están puestas.
    // Sentry.replayIntegration(),
  ],
  environment: environment.environment,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Los tres, y no solo el primero: `beforeSend` no alcanza ni a las transacciones ni a los
  // breadcrumbs, que es donde viajan el span de routing de Angular y la navegación.
  beforeSend: (event) => scrubEvent(event),
  beforeSendTransaction: (event) => scrubEvent(event),
  beforeBreadcrumb: (breadcrumb) => scrubBreadcrumb(breadcrumb),
});


if (environment.production) {
  enableProdMode();
}

defineCustomElements(window)

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
